"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersionOverrideFromQueryParams = exports.hasDebugParam = void 0;
const win_1 = require("../win");
const getSearchParams = () => { var _a; return typeof URLSearchParams !== 'undefined' ? new URLSearchParams((_a = win_1.win === null || win_1.win === void 0 ? void 0 : win_1.win.location) === null || _a === void 0 ? void 0 : _a.search) : null; };
const hasDebugParam = () => { var _a; return !!((_a = getSearchParams()) === null || _a === void 0 ? void 0 : _a.has('debug')); };
exports.hasDebugParam = hasDebugParam;
const getVersionOverrideFromQueryParams = (artifactName) => { var _a; 
// syntax based on https://github.com/wix-private/editor-elements/blob/master/website/docs/development/local-dev.md#query-params
return (_a = getSearchParams()) === null || _a === void 0 ? void 0 : _a.get(`${artifactName}-override`); };
exports.getVersionOverrideFromQueryParams = getVersionOverrideFromQueryParams;
//# sourceMappingURL=client.js.map